import { createContext } from "react";

export const AmountContext = createContext<any>({});
export const AddressContext = createContext<any>({});
export const PriorityContext = createContext<any>({});
export const BtcAmountContext = createContext<any>({});
export const FiatAmountContext = createContext<any>({});
export const HandleForgotPinContext = createContext<any>(null);
